import { useState } from "react";
import { SettingsLayout } from "@/components/layout/SettingsLayout";
import { ProfileList } from "@/components/matrix/ProfileList";
import { WeightEditor } from "@/components/matrix/WeightEditor";

export function ProfilesPage() {
  const [editingProfileId, setEditingProfileId] = useState<string | null>(null);

  return (
    <SettingsLayout>
      <div className="space-y-6">
        {editingProfileId ? (
          <WeightEditor profileId={editingProfileId} onBack={() => setEditingProfileId(null)} />
        ) : (
          <>
            <div>
              <h2 className="text-2xl font-bold">Asset Profiles</h2>
              <p className="text-muted-foreground">
                Manage CRE asset profiles and their metric weights.
              </p>
            </div>
            <ProfileList onSelectProfile={setEditingProfileId} />
          </>
        )}
      </div>
    </SettingsLayout>
  );
}
